export default "__VITE_ASSET__Dauz2sPm__"